module.exports = __webpack_public_path__ + "media/notif-call-waiting.f948c2bd.mp3";